export default __webpack_public_path__ + "static/media/mp4SVG.f865b480.svg";